<div class="result-page">
  <div class="container">
    <div class="icon-wrapper success">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    </div>

    <h1>Pagamento Completato!</h1>

    <p class="main-message">
      Il pagamento per la tua iscrizione e stato completato con successo.
    </p>

    <p class="sub-message">
      Riceverai una email di conferma con tutti i dettagli all'indirizzo
      fornito durante l'iscrizione.
    </p>

    <div class="actions">
      <a routerLink="/eventi" class="primary-btn">Torna agli eventi</a>
      <a routerLink="/" class="secondary-btn">Torna alla Home</a>
    </div>
  </div>
</div>
